/*
 * Opens the header mega menu on hover, matching the behaviour of the
 * Qikify Smart Menu app it replaces (trigger: hover).
 *
 * Only toggles the `open` attribute on Dawn's <details> element, so the
 * existing <header-menu> custom element keeps handling focus, sticky-header
 * positioning and the fade animation. Click and keyboard still work as before.
 *
 * Desktop pointer devices only — touch devices keep tap-to-open.
 */
(function () {
  const CLOSE_DELAY = 150;
  const query = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

  function init() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
      if (menu.dataset.hoverBound === 'true') return;
      menu.dataset.hoverBound = 'true';

      const details = menu.querySelector('details');
      const summary = details && details.querySelector('summary');
      if (!details || !summary) return;

      let closeTimer;

      const open = () => {
        if (!query.matches) return;
        clearTimeout(closeTimer);

        // Close any sibling menu that hover left open.
        document.querySelectorAll('.header__inline-menu details[open]').forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });

        if (!details.open) {
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }
      };

      const close = () => {
        if (!query.matches) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          if (menu.contains(document.activeElement)) return;
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY);
      };

      menu.addEventListener('mouseenter', open);
      menu.addEventListener('mouseleave', close);

      // Without this, clicking an already hover-opened item would close it.
      summary.addEventListener('click', (event) => {
        if (query.matches && details.open) event.preventDefault();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind when the header section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
